import { produce } from "immer";
import { theme } from "../../theme/theme";
import { CLEAR_ALL_ERROR_MESSAGE, CLEAR_ERROR_MESSAGE, LOAD_API_DATA, SET_API_DATA, SET_ERROR_MESSAGE, SET_FORM_OPTION, SET_FORM_VALUE, SET_FORM_VALUEOBJ } from "./accessManagement.type";
const INITAL_STATE = {
    apiData: {
        domainSubDomain: {
            status: "idle",
            data: [],
            isError: false,
            errorMessage: "",
            loading: false
        },
        accessManagementList: {
            status: "idle",
            data: [ {name:"Alex John",email:"alexjohn@example.com",region:"Europe",country:"UK",domain:"Supply",subDomain:"Inventory",role_id:"34345345645465",permission_id:"686868968686"}
            ],
            isError: false,
            errorMessage: "",
            loading: false
        },
        editingAlert: {
            status: "idle",
            data: [],
            isError: false,
            errorMessage: "",
            loading: false
        },
        deletingAlert: {
            status: "idle",
            data: [],
            isError: false,
            errorMessage: "",
            loading: false
        },
        
    },
    formData: {
        domainSubDomainForm: {
            value: "",
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        domain: {
            value: "",
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        subDomain: {
            value: "",
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        name: {
            value: "",
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        email: {
            value: "",
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        access: {
            value: "",
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        country: {
            value: "",
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        region: {
            value: "",
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        }
    }

}

const AccessManagementReducer = (state = INITAL_STATE, { type, payload }) => {
    switch (type) {
        case SET_FORM_VALUE: {
            return produce(state, (draft) => {

                draft.formData[payload.formField].value = payload.value
            });
        }
        case SET_FORM_VALUEOBJ: {
            return produce(state, (draft) => {
                draft.formData[payload.formField].valueAsObj = payload.valueAsObj
            });
        }
        case SET_ERROR_MESSAGE: {
            return produce(state, (draft) => {
                draft.formData[payload.formField].isError = payload.isError
                draft.formData[payload.formField].errorMessage = payload.errorMessage
            });
        }
        case CLEAR_ERROR_MESSAGE: {
            return produce(state, (draft) => {
                draft.formData[payload.formField].isError = false
                draft.formData[payload.formField].errorMessage = ""
            });
        }
        case CLEAR_ALL_ERROR_MESSAGE: {
            return produce(state, (draft) => {
                Object.keys(draft.formData).forEach((val) => {
                    draft.formData[val].isError = false
                    draft.formData[val].errorMessage = ""
                })

            });
        }
        case LOAD_API_DATA:
            return produce(state, (draft) => {
                draft.apiData[payload.apiField].loading = true
                draft.apiData[payload.apiField].status = "loading"
            })
        case SET_API_DATA:
            return produce(state, (draft) => {
                draft.apiData[payload.apiField].loading = false;
                draft.apiData[payload.apiField].status =
                    payload.status !== undefined && payload.status !== null
                        ? payload.status
                        : "success";
                draft.apiData[payload.apiField].data = payload.data;
            });
        case SET_FORM_OPTION:
            return produce(state, (draft) => {
                draft.formData[payload.formField].loading = false;
                draft.formData[payload.formField].options = payload.data;
            });
        // Return the current state if no action matches
        default:
            return state;
    }
}
export default AccessManagementReducer;